import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'reactstrap';
import { FlexStartRow } from './FormElements';

export default class WarningMessageDisplay extends React.Component {
    render() {
        return (<div
            hidden={(Object.keys(this.props.warnings ?? {}) ?? []).length <= 0}
            className="col-xl-6 col-md-12 mt-1 offset-xl-3 d-flex flex-column justify-content-center">
            <Alert
                color="warning"
                className="d-flex flex-column flex-nowrap position-relative pr-3">
                <FontAwesomeIcon
                    style={{ position: 'absolute', top: '10px', right: '10px' }}
                    size="lg"
                    icon={faExclamationTriangle}
                    className="close-validation-warnings cursor-pointer"
                    onClick={this.props.onClear} />
                <span>{this.props.warningMessageHeader ?? "Warning:"}</span>
                <ul>
                    {(Object.keys(this.props.warnings ?? {}) ?? []).map(k =>
                        <li key={k} className="d-flex flex-column flex-nowrap">
                            <FlexStartRow><FontAwesomeIcon icon={faCircle} style={{ fontSize: '6px' }} className="mr-2" /><b>{k}</b></FlexStartRow>
                            <span className="ml-3">{this.props.warnings[k]}</span>
                        </li>
                    )}
                </ul>
            </Alert>
        </div>)
    }
}